// 默认storage 方式
const defaultStorageType = 'sessionStorage'
// 设置storage
export const setStorage = (key = '', value = '', storageType = defaultStorageType) => {
  if (!window) return;
  switch (storageType) {
    case 'localStorage':
      return window.localStorage.setItem(key, value);
    default:
      return window.sessionStorage.setItem(key, value)
  }
}

// 获取storage
export const getStorage = (key = '', storageType = defaultStorageType) => {
  if (!window) return;
  switch (storageType) {
    case 'localStorage':
      return window.localStorage.getItem(key) || '';
    default:
      return window.sessionStorage.getItem(key) || ''
  }
}
// 删除storage
export const deleteStorage = (key = '', storageType = defaultStorageType) => {
  if (!window) return;
  switch (storageType) {
    case 'localStorage':
      return window.localStorage.removeItem(key);
    default:
      return window.sessionStorage.removeItem(key);
  }
}
// 清空storage
export const clearStorage = (storageType = defaultStorageType) => {
  if (!window) return;
  switch (storageType) {
    case 'localStorage':
      return window.localStorage.clear();
    default:
      return window.sessionStorage.clear();
  }
}